import { Answer } from '../types/Answer';
function collect(state, path) {
    let stats = {
        total: 0,
        [Answer.Yes]: 0,
        [Answer.MostlyYes]: 0,
        [Answer.MostlyNo]: 0,
        [Answer.No]: 0,
        [Answer.NotRelevant]: 0,
    };
    Object.values(state)
        .filter((it) => (path.length < 1 || it.fieldIndex === path[0]) &&
        (path.length < 2 || it.sectionIndex === path[1]) &&
        (path.length < 3 || it.subsectionIndex === path[2]) &&
        (path.length < 4 || it.statementIndex === path[3]))
        .forEach((it) => {
        stats.total++;
        if (it['answer'] !== undefined) {
            stats[it.answer]++;
        }
    });
    return stats;
}
export const StatsCollector = {
    collect,
};
